import * as React from 'react';
export function useModalGallery(params) {
    const [modalGalleryState, dispatch] = React.useReducer(modalGalleryReducer, {
        activeIndex: 0,
        maxIndex: 0,
    });
    React.useEffect(() => {
        initModalGallery();
    }, [params.count]);
    return {
        ...modalGalleryState,
        goToIndex,
        goToNext,
        goToPrev,
    };
    /**
     * Initialise the reducer state.
     */
    function initModalGallery() {
        // Initialise the modalGallery state.
        dispatch({ type: 'init', payload: { maxIndex: params.count - 1 } });
    }
    /**
     * Go to the next item.
     */
    function goToNext(wrap) {
        dispatch({ type: 'next', payload: { wrap: wrap ?? false } });
    }
    /**
     * Go to the previous item.
     */
    function goToPrev(wrap) {
        dispatch({ type: 'prev', payload: { wrap: wrap ?? false } });
    }
    /**
     * Go to the target index.
     */
    function goToIndex(index) {
        dispatch({ type: 'goto', payload: index });
    }
    function modalGalleryReducer(state, action) {
        switch (action.type) {
            case 'init':
                return {
                    activeIndex: 0,
                    maxIndex: action.payload.maxIndex,
                };
            case 'goto':
                return { ...state, activeIndex: clamp(action.payload) };
            case 'next':
                if (action.payload.wrap && state.activeIndex === state.maxIndex) {
                    return { ...state, activeIndex: 0 };
                }
                return { ...state, activeIndex: clamp(state.activeIndex + 1) };
            case 'prev':
                if (action.payload.wrap && state.activeIndex === 0) {
                    return { ...state, activeIndex: state.maxIndex };
                }
                return { ...state, activeIndex: clamp(state.activeIndex - 1) };
        }
        /** Clamp index to be within the min/max index range. */
        function clamp(value) {
            return Math.max(Math.min(value, state.maxIndex), 0);
        }
    }
}
